<template>
  <div class="layout--default">
    <AppNavigation></AppNavigation>
    <v-main>
      <v-row>
        <v-col cols="12" md="9">
          <v-card class="content-card">
            <router-view></router-view>
          </v-card>
        </v-col>
        <v-col cols="2" md="3">
          <SessionHistory class="SH-card" />
        </v-col>
      </v-row>
    </v-main>
  </div>
</template>

<script>
import AppNavigation from "@/components/app/AppNavigation.vue";
import SessionHistory from "@/components/BaseSessionHistory.vue";

export default {
  components: {
    AppNavigation,
    SessionHistory
  }
};
</script>

<style lang="scss" scoped>
.layout--default,
.v-content {
  height: 100%;
}

.v-toolbar__extension {
  height: 6rem;
}
.content-card {
  margin: -82px 1.5rem 0;
  height: calc(100vh - (64px + 1.5rem));
  margin-right: 0;
  overflow: auto;
}
.SH-card {
  margin: -82px 0.5rem 0;
  margin-left: 0;
  overflow: auto;
}
</style>
